export const deductionModes = [
  {
    value: "Calculated",
    text: "Apply the usual deduction",
  },
  {
    value: "NoDeduct",
    text: "Do not deduct",
  },
];

export function normalizeDeductionMode(mode) {
  return mode === "NoDeduct" ? "NoDeduct" : "Calculated";
}

export function deductionModeLabel(mode) {
  const match = deductionModes.find(
    (item) => item.value === normalizeDeductionMode(mode)
  );
  return match ? match.text : deductionModes[0].text;
}

export function canEditExistingDeductions(store) {
  const isAdmin = store.getters["authentication/isAdmin"];
  if (isAdmin && isAdmin != "false") return true;

  const raw = store.state.authentication.roles;
  const roles = Array.isArray(raw)
    ? raw
    : raw
    ? String(raw).split(",")
    : [];

  return (
    roles.indexOf("AbsentDeductionAdmin") !== -1 ||
    roles.indexOf("Admin") !== -1
  );
}
